import { Modal, Button } from 'react-bootstrap';

export default function MayoristaModal({ show, handleClose }) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Venta Mayorista</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-4">
          <p className="pnegro"><strong>¡Hola! ¿Cómo estás?</strong></p>
          <p className="pnegro">¿Querés vender <em>Cardúmenes</em> en tu tienda?</p>
          <p className="pnegro">Registrate en nuestra tienda mayorista y hacé tu pedido!</p>
          <p className="pnegro">Para que puedas comenzar a operar tenemos que aprobar tu registro, para acelerar el proceso escribinos por Whatsapp.</p>
        </div>

        <Button 
          variant="success" 
          href="https://b2b.kitsunegames.ar" 
          target="_blank" 
          rel="noopener noreferrer"
          className="w-100"
          onClick={handleClose}
        >
          Ir a la Tienda Mayorista
        </Button>
      </Modal.Body>
    </Modal>
  );
}